import { motion } from "framer-motion";

interface BubbleBackgroundProps {
  variant?: "light" | "dark";
  density?: "sparse" | "normal" | "dense";
}

export const BubbleBackground = ({ variant = "light", density = "normal" }: BubbleBackgroundProps) => {
  const bubbleCount = density === "sparse" ? 6 : density === "dense" ? 15 : 10;
  
  const bubbles = Array.from({ length: bubbleCount }, (_, i) => ({
    id: i,
    size: Math.random() * 80 + 40,
    left: Math.random() * 100,
    top: Math.random() * 100,
    delay: Math.random() * 5,
    duration: Math.random() * 10 + 15,
  }));

  const isDark = variant === "dark";

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {bubbles.map((bubble) => (
        <motion.div
          key={bubble.id}
          className="absolute rounded-full"
          style={{
            width: bubble.size,
            height: bubble.size,
            left: `${bubble.left}%`,
            top: `${bubble.top}%`,
            background: isDark
              ? `radial-gradient(ellipse at 30% 30%, hsl(200 90% 85% / 0.18) 0%, hsl(200 80% 75% / 0.06) 55%, transparent 75%)`
              : `radial-gradient(ellipse at 30% 30%, hsl(215 80% 70% / 0.12) 0%, hsl(215 80% 50% / 0.04) 50%, transparent 70%)`,
            border: isDark
              ? `1px solid hsl(200 90% 85% / 0.08)`
              : `1px solid hsl(215 80% 70% / 0.08)`,
          }}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{
            opacity: isDark ? [0.35, 0.6, 0.35] : [0.3, 0.6, 0.3],
            scale: [1, 1.05, 1],
            y: [-10, 10, -10],
          }}
          transition={{
            duration: bubble.duration,
            delay: bubble.delay,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        >
          {/* Highlight reflection */}
          <div
            className="absolute rounded-full"
            style={{
              top: "15%",
              left: "20%",
              width: "30%",
              height: "20%",
              background: isDark
                ? "hsl(0 0% 100% / 0.15)"
                : "hsl(0 0% 100% / 0.25)",
              filter: "blur(2px)",
            }}
          />
        </motion.div>
      ))}
    </div>
  );
};
